export default "__VITE_ASSET__BgIzYhXd__"